<template>
  <section class="batch-modify">
    <header class="batch-head">
      <div class="crumb">
        <button class="plain" @click="$emit('back')">‹ 返回</button>
        <span>
          商品工作台　›　批量修改　›　
          <strong>导购短标题</strong>
        </span>
        <a>帮助教程</a>
      </div>
      <h1>批量修改导购短标题</h1>
      <nav>
        <button :class="{ active: mode === 'range' }" @click="switchMode('range')">按范围修改</button>
        <button :class="{ active: mode === 'goods' }" @click="switchMode('goods')">按商品修改</button>
      </nav>
    </header>
    <main class="batch-body">
      <section class="panel">
        <div v-if="mode === 'goods'" class="picked">
          <button @click="openSelector">选择商品</button>
          <span>
            已选择
            <b>{{ selected.length }}</b>
            个商品
          </span>
        </div>
        <div v-if="mode === 'range'" class="filters">
          <label v-for="field in shownSearchFields" :key="field.key" class="field">
            <span>
              {{ field.label }}
              <small v-if="field.runtime">（需核验数据）</small>
            </span>
            <doudian-category-cascader
              v-if="field.key === 'category_id'"
              v-model="filterValues.category_id"
              :categories="categoryTree" />
            <el-date-picker
              v-else-if="field.date"
              v-model="filterValues[field.key]"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始时间"
              end-placeholder="结束时间" />
            <div v-else-if="field.matchKey" class="combined-control">
              <el-select v-model="filterValues[field.matchKey]" :aria-label="field.label + '匹配方式'">
                <el-option
                  v-for="option in field.matchOptions"
                  :key="option.value"
                  :value="option.value"
                  :label="option.label" />
              </el-select>
              <div v-if="field.range" class="range">
                <input
                  v-model="filterValues[field.key + '_min']"
                  :aria-label="field.label + '最小值'"
                  placeholder="最小值" />
                <span>~</span>
                <input
                  v-model="filterValues[field.key + '_max']"
                  :aria-label="field.label + '最大值'"
                  placeholder="最大值" />
              </div>
              <input
                v-else
                v-model="filterValues[field.key]"
                :aria-label="field.label"
                :disabled="filterValues[field.matchKey] === 'empty'"
                :placeholder="
                  filterValues[field.matchKey] === 'empty' ? '无需填写' : field.placeholder || '请输入' + field.label
                " />
            </div>
            <div v-else-if="field.range" class="range">
              <input v-model="filterValues[field.key + '_min']" placeholder="最小值" />
              <span>~</span>
              <input v-model="filterValues[field.key + '_max']" placeholder="最大值" />
            </div>
            <el-select v-else-if="field.options" v-model="filterValues[field.key]" clearable>
              <el-option
                v-for="option in field.options"
                :key="String(option.value)"
                :value="option.value"
                :label="option.label" />
            </el-select>
            <input v-else v-model="filterValues[field.key]" :placeholder="field.placeholder || '请输入条件'" />
          </label>
        </div>
        <footer v-if="mode === 'range'" class="filter-actions">
          <div class="shops">
            <el-select v-model="store" multiple collapse-tags placeholder="选择抖店" :disabled="confirming">
              <el-option-group v-if="selectableSearchShops.length" label="抖店">
                <el-option
                  v-for="shop in selectableSearchShops"
                  :key="shop.mer_shop_id"
                  :value="Number(shop.mer_shop_id)"
                  :label="shop.shop_name">
                  {{ shop.shop_name }}
                </el-option>
              </el-option-group>
            </el-select>
          </div>
          <div class="filter-buttons">
            <button class="more-search" @click="searchMore = !searchMore">
              {{ searchMore ? '收起更多搜索 ▴' : '更多搜索 ▾' }}
            </button>
            <button :disabled="loading || confirming" @click="loadPreview(1)">查询</button>
            <button class="plain" @click="resetFilters">重置</button>
          </div>
        </footer>
        <p v-if="mode === 'range'" class="hint">
          不同条件同时满足才命中；一个 SKU 满足已设置的 SKU
          条件即可命中商品。条件筛选有些无法直接查询结果，通过数据命中来判断是否符合。
        </p>
      </section>
      <doudian-batch-common-options v-model="commonOptions" :disabled="loading || confirming" />
      <section class="panel methods bm-short-title__strategy">
        <h3>
          <i></i>
          修改策略
        </h3>
        <div class="bm-short-title__strategy-body">
          <label>
            <el-checkbox v-model="conditions.skip_existing" :disabled="hasClearMethod || hasAdvancedMethod">
              若商品已有导购短标题，则不进行修改
            </el-checkbox>
          </label>
        </div>
      </section>
      <section class="panel methods">
        <h3>
          <i></i>
          修改内容
        </h3>
        <article v-for="method in methods" :key="method.type" class="rule-row">
          <el-checkbox
            v-model="method.on"
            :disabled="isMethodDisabled(method)"
            @change="handleMethodChange(method, $event)"
            class="bm-title__method-name">
            方式{{ method.order }}：{{ method.name }}
          </el-checkbox>
          <div class="rule-options">
            <template v-if="method.type === 401">
              <div class="bm-title__count-input">
                <input
                  v-model="form.value"
                  class="long"
                  maxlength="10000"
                  placeholder="短标题字数要求：4-12个汉字（即8-24字符）" />
                <small>{{ characterCount(form.value) }} 字符</small>
              </div>
            </template>
            <template v-else-if="method.type === 402">
              使用标题
              <el-input-number
                v-model="form.length"
                size="mini"
                class="bm-short-title__length-input"
                :min="4"
                :max="12"
                controls-position="right" />
              <span>个字</span>
              <span class="bm-short-title__from-title-options">
                <el-checkbox
                  :value="form.fromTitleDirection === 'tail'"
                  @change="setFromTitleDirection('tail', $event)">
                  删除标题后面的文字
                </el-checkbox>
                <el-checkbox
                  :value="form.fromTitleDirection === 'head'"
                  @change="setFromTitleDirection('head', $event)">
                  删除标题前面的文字
                </el-checkbox>
              </span>
            </template>
            <template v-else-if="method.type === 403">
              <span>将导购短标题清空</span>
            </template>
            <template v-else-if="method.type === 104">
              <div class="bm-title__count-textarea">
                <textarea
                  v-model="form.keywords"
                  maxlength="10000"
                  placeholder="多个关键词用逗号分隔，最多10000字"></textarea>
                <small>{{ characterCount(form.keywords) }}/10000</small>
              </div>
            </template>
            <template v-else-if="method.type === 105">
              <el-checkbox
                v-for="option in filterOptions"
                :key="option.value"
                v-model="form.filters"
                :label="option.value">
                {{ option.label }}
              </el-checkbox>
            </template>
            <template v-else-if="method.type === 107">
              <div v-for="(replace, replaceIndex) in form.replaces" :key="replaceIndex" class="bm-title__replace">
                <input v-model="replace.find" placeholder="查找内容" />
                <span>→</span>
                <input v-model="replace.value" placeholder="替换为" />
                <button @click="addReplace">＋ 添加</button>
                <button v-if="replaceIndex" class="danger" @click="removeReplace(replaceIndex)">删除</button>
              </div>
            </template>
            <template v-else-if="method.type === 108">
              <div class="bm-title__inline">
                <span>前缀</span>
                <input v-model="form.prefix" placeholder="前缀内容" />
                <span>后缀</span>
                <input v-model="form.suffix" placeholder="后缀内容" />
              </div>
            </template>
            <template v-else>
              <span>替换前内容</span>
              <input v-model="form.before" placeholder="原前缀" />
              <span>替换后内容</span>
              <input v-model="form.after" placeholder="新前缀" />
              <small class="warning">仅替换匹配的原标题前缀；替换后内容可为空</small>
            </template>
          </div>
        </article>
      </section>
      <p class="bm-short-title__notice">短标题按显示宽度保留 8–24 字符，超长从尾部截断。</p>
      <section v-if="preview" class="panel preview">
        <doudian-batch-preview-notice />
        <header>
          已选择
          <b>{{ mode === 'goods' ? selected.length : previewPage.total }}</b>
          个商品，当前预览
          <b>{{ previewPage.total }}</b>
          个，已排除 {{ excludedProductIds.length }} 个
          <button @click="preview = false">收起预览</button>
        </header>
        <table>
          <colgroup>
            <col class="bm-title__col-product" />
            <col class="bm-title__col-new-title" />
            <col class="bm-title__col-action" />
          </colgroup>
          <thead>
            <tr>
              <th>商品信息</th>
              <th>调整后短标题 / 预计结果</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(good, n) in previewGoods"
              :key="good.id || good.product_id || n"
              :class="{
                'is-excluded': isExcluded(good),
                'is-error': isPreviewError(good),
                'is-unknown': good.preview_result === 'unknown'
              }">
              <td>
                <div class="bm-title__product-info">
                  <el-image
                    class="bm-title__image"
                    :src="imageOf(good)"
                    fit="cover"
                    :preview-src-list="[imageOf(good)]" />
                  <div>
                    <div class="bm-title__product-ids">
                      <small>商品ID：{{ productId(good) }}</small>
                      <small v-if="good.platform_product_id">平台商品ID：{{ good.platform_product_id }}</small>
                    </div>
                    <small>店铺：{{ good.shop_name || '—' }}</small>
                    <p>{{ titleOf(good) }}</p>
                    <small>
                      原短标题：{{
                        good.value_ready === false
                          ? '本地数据缺失，待核验'
                          : good.old_short_title == null || good.old_short_title === ''
                          ? '未设置'
                          : good.old_short_title
                      }}
                    </small>
                  </div>
                </div>
              </td>
              <td>
                <textarea
                  :value="previewShortTitle(good)"
                  readonly
                  :class="{
                    'is-error': isPreviewError(good),
                    'is-unchanged': good.preview_result === 'skipped'
                  }"></textarea>
                <div v-if="good.match_reason" class="bm-title__preview-error">{{ good.match_reason }}</div>
                <div v-if="good.shelf_only" class="bm-title__preview-error">短标题未变化，检查尺码表后调整上下架</div>
                <div v-if="good.error_msg || good.preview_result === 'skipped'" class="bm-title__preview-error">
                  {{
                    good.error_msg ||
                    (good.skip_reason === 'existing' ? '已有短标题，跳过修改' : '内容未变化，跳过修改')
                  }}
                </div>
              </td>
              <td>
                <button :class="{ 'is-excluded': isExcluded(good) }" @click="toggleExclude(good)">
                  {{ isExcluded(good) ? '取消排除' : '排除修改' }}
                </button>
              </td>
            </tr>
            <tr v-if="!loading && previewGoods.length === 0" class="bm-title__empty-row">
              <td colspan="3">暂无数据</td>
            </tr>
          </tbody>
        </table>
        <footer class="bm-title__pagination">
          <span class="bm-title__pagination-total">共 {{ previewPage.total }} 条</span>
          <div class="bm-title__pagination-actions">
            <el-pagination
              :current-page="previewPage.page"
              :page-size="previewPage.limit"
              :total="previewPage.total"
              layout="prev, pager, next"
              small
              @current-change="loadPreview" />
            <span class="bm-title__pagination-jump">
              前往
              <input v-model.number="previewJumpPage" min="1" type="number" @keyup.enter="jumpPreviewPage" />
              页
            </span>
          </div>
        </footer>
      </section>
    </main>
    <footer class="actions">
      <button class="preview-button" :disabled="loading || confirming" @click="loadPreview()">修改内容预览</button>
      <span v-if="preview && !previewIsCurrent" class="bm-short-title__stale">条件已变化，请重新预览</span>
      <button class="start" :disabled="loading || confirming" @click="startBatch">开始批量修改</button>
      <label>
        <input v-model="scheduled" type="checkbox" @change="toggleSchedule" />
        定时执行
      </label>
      <button v-if="scheduled" class="time" @click="openSchedule">
        {{ scheduleText }}
      </button>
    </footer>
    <div v-if="moreSearch" class="bm-title__mask">
      <div class="bm-title__more-modal">
        <header>
          <strong>支持更多搜索</strong>
          <button @click="moreSearch = false">×</button>
        </header>
        <main>
          <el-checkbox-group v-model="moreSearchDraft">
            <el-checkbox v-for="field in moreSearchFields" :key="field" :label="field">{{ field }}</el-checkbox>
          </el-checkbox-group>
        </main>
        <footer>
          <button class="plain" @click="resetMoreSearch">重置默认</button>
          <button class="plain" @click="closeMoreSearch">取消</button>
          <button @click="applyMoreSearch">应用</button>
        </footer>
      </div>
    </div>
    <product-selector-dialog
      :visible="selecting"
      :active-tab="selectorTab"
      :products="selectorTab === 'all' ? goods : selectedPageGoods"
      :selected-ids="selectorSelected"
      :loading="selectorTab === 'all' && selectorLoading"
      :page="selectorDialogPage"
      :page-size="selectorPage.limit"
      :page-sizes="[20, 50, 100]"
      :total="selectorDialogTotal"
      :total-pages="selectorDialogPageCount"
      :jump-page="selectorDialogJumpPage"
      :page-fully-selected="isPageFullySelected"
      :product-id="productId"
      :product-key="productId"
      :product-title="titleOf"
      :product-image="imageOf"
      :product-price="priceOf"
      @close="closeSelector"
      @confirm="confirmSelector"
      @tab-change="switchSelectorTab"
      @toggle-product="toggleGood"
      @toggle-page="togglePageSelection"
      @page-change="changeSelectorPage"
      @page-size-change="changeSelectorPageSize"
      @jump-input="changeSelectorJumpPage"
      @jump="jumpSelectorPage">
      <template #filters>
        <doudian-product-selector-filters
          :value="selectorFilters"
          :shop-id="selectorShopId"
          :shops="selectableSearchShops"
          :categories="categoryTree"
          @shop-change="changeSelectorShop"
          @query="querySelector" />
      </template>
    </product-selector-dialog>
    <div v-if="schedule" class="bm-title__mask">
      <div class="bm-title__small-modal">
        <header>
          <strong>定时执行</strong>
          <button @click="closeSchedule">×</button>
        </header>
        <main>
          <label>
            执行时间
            <el-date-picker
              v-model="scheduleDraft"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="请选择执行时间"
              :clearable="false"
              popper-class="bm-title__schedule-popper"
              class="bm-title__schedule-picker" />
          </label>
        </main>
        <footer>
          <button class="plain" @click="closeSchedule">取消</button>
          <button @click="confirmSchedule">确定</button>
        </footer>
      </div>
    </div>
    <div v-if="success" class="bm-title__mask">
      <div class="bm-title__small-modal">
        <header>
          <strong>提示</strong>
          <button @click="success = false">×</button>
        </header>
        <main class="success-message">
          <b>✓</b>
          <p>批量修改任务创建成功</p>
          <small>任务将在后台处理，请在批量修改记录中查看进度。</small>
        </main>
        <footer><button @click="success = false">我知道了</button></footer>
      </div>
    </div>
  </section>
</template>

<script>
import { fields as sharedSearchFields, pairedFields, defaults as searchDefaults } from './batchModifyFilters'
import { buildBatchProductFilter } from './batchModifyFilters'

import {
  createDoudianShortTitleBatch,
  previewDoudianShortTitleBatch,
  getDoudianCategories,
  getAuthSuccessShopList,
  getProductSelectorProducts
} from '@/api/main/doudianBatchEdit'
import DoudianCategoryCascader from '@/components/DoudianCategoryCascader'
import ProductSelectorDialog from '@/components/ProductSelectorDialog/ProductSelectorDialog'
import DoudianProductSelectorFilters from './DoudianProductSelectorFilters.vue'
import DoudianBatchCommonOptions, {
  describeCommonOptions,
  batchPreviewNotice
} from '@/components/DoudianBatchCommonOptions'
import DoudianBatchPreviewNotice from '@/components/DoudianBatchCommonOptions/PreviewNotice.vue'

const fields = [
  { key: 'category_id', label: '商品分类', select: true, options: [] },
  {
    key: 'status',
    label: '商品状态',
    select: true,
    options: [
      { value: 3, label: '在售' },
      { value: 4, label: '仓库中' },
      { value: 6, label: '草稿' }
    ]
  },
  { key: 'product_title', label: '标题包含', placeholder: '请输入标题关键词' },
  { key: 'platform_product_id', label: '抖店商品ID', placeholder: '请输入抖店商品ID' },
  { key: 'price_range', label: '售价范围（元）', range: true, rangeKeys: ['price_min', 'price_max'] },
  { key: 'created_at', label: '创建时间', datetimeRange: true },
  { key: 'sales_range', label: '销量（件）', range: true, rangeKeys: ['sales_min', 'sales_max'] }
]
const defaultFilterValues = fields.reduce((values, field) => {
  if (field.datetimeRange) values[field.key] = []
  else if (field.range)
    field.rangeKeys.forEach((key) => {
      values[key] = ''
    })
  else if (field.key === 'category_id') values[field.key] = { level1: [], level2: [], level3: [] }
  else values[field.key] = ''
  return values
}, {})
export default {
  name: 'BatchModifyShortTitle',
  components: {
    DoudianCategoryCascader,
    DoudianProductSelectorFilters,
    ProductSelectorDialog,
    DoudianBatchCommonOptions,
    DoudianBatchPreviewNotice
  },
  data() {
    return {
      mode: 'range',
      commonOptions: { auto_generate_size_chart: false, shelf_action: 0 },
      fields,
      filterValues: searchDefaults(),
      searchMore: false,
      store: [],
      shops: [],
      moreSearch: false,
      moreSearchFields: fields.map((field) => field.label),
      moreSearchChecked: fields.map((field) => field.label),
      moreSearchDraft: [],
      preview: false,
      previewGoods: [],
      previewPage: { page: 1, limit: 20, total: 0 },
      previewJumpPage: 1,
      previewSignature: '',
      previewRequestId: 0,
      selectorRequestId: 0,
      confirming: false,
      excludedProductIds: [],
      loading: false,
      selecting: false,
      selectorTab: 'all',
      selectorShopId: '',
      selectorFilters: {
        category_id: { level1: [], level2: [], level3: [] },
        platform_product_id: '',
        product_title: '',
        created_at: [],
        tab_status: ''
      },
      selectorPage: { page: 1, limit: 20, total: 0 },
      selectorJumpPage: 1,
      selectedPage: 1,
      selectedJumpPage: 1,
      selectorLoading: false,
      success: false,
      schedule: false,
      scheduled: false,
      scheduleText: '',
      scheduleDraft: '',
      selected: [],
      selectedGoods: [],
      selectorSelected: [],
      selectorSelectedGoods: [],
      methods: [401, 402, 403, 104, 105, 107, 108, 110].map((type, index) => ({
        type,
        order: index + 1,
        name: [
          '统一设置',
          '使用标题生成',
          '清空导购短标题',
          '删除关键词',
          '过滤设置',
          '关键词替换',
          '增加前后缀',
          '替换前后缀'
        ][index],
        on: false
      })),
      form: {
        value: '',
        length: 12,
        fromTitleDirection: 'tail',
        keywords: '',
        filters: [],
        replaces: [{ find: '', value: '' }],
        prefix: '',
        suffix: '',
        before: '',
        after: ''
      },
      filterOptions: [
        { label: '去除英文', value: 301 },
        { label: '去除数字', value: 302 },
        { label: '去除全部空格', value: 303 },
        { label: '仅去除首尾空格', value: 304 },
        { label: '去除英文符号', value: 305 },
        { label: '去除括号及内容', value: 307 },
        { label: '去除逗号', value: 308 }
      ],
      goods: [],
      categoryTree: [],
      conditions: { skip_existing: false }
    }
  },
  computed: {
    selectableSearchShops() {
      return this.shops.filter((shop) => Number(shop.shop_type) !== 2 && shop.selectable !== false)
    },
    shownSearchFields() {
      return sharedSearchFields
        .filter(
          (field) =>
            !Object.values(pairedFields).includes(field.key) &&
            (!field.more || this.searchMore) &&
            (this.mode === 'range' ||
              !['platform_product_id', 'created_at', 'category_id', 'status'].includes(field.key))
        )
        .map((field) =>
          pairedFields[field.key]
            ? {
                ...field,
                matchKey: pairedFields[field.key],
                matchOptions: sharedSearchFields.find((item) => item.key === pairedFields[field.key]).options
              }
            : field
        )
    },

    visibleFields() {
      return this.fields.filter((field) => this.moreSearchChecked.includes(field.label))
    },
    previewIsCurrent() {
      return this.previewSignature !== '' && this.previewSignature === this.previewPayloadSignature()
    },
    pageCount() {
      return Math.max(1, Math.ceil(Number(this.previewPage.total || 0) / Number(this.previewPage.limit || 20)))
    },
    selectorPageCount() {
      return Math.max(1, Math.ceil(Number(this.selectorPage.total || 0) / Number(this.selectorPage.limit || 20)))
    },
    selectedPageCount() {
      return Math.max(1, Math.ceil(this.selectorSelectedGoods.length / Number(this.selectorPage.limit || 20)))
    },
    selectedPageGoods() {
      const start = (this.selectedPage - 1) * this.selectorPage.limit
      return this.selectorSelectedGoods.slice(start, start + this.selectorPage.limit)
    },
    selectedPlatformProductIds() {
      return this.selectedGoods.map((good) => String(good.platform_product_id || '')).filter(Boolean)
    },
    selectorDialogPage() {
      return this.selectorTab === 'all' ? this.selectorPage.page : this.selectedPage
    },
    selectorDialogTotal() {
      return this.selectorTab === 'all' ? this.selectorPage.total : this.selectorSelectedGoods.length
    },
    selectorDialogPageCount() {
      return this.selectorTab === 'all' ? this.selectorPageCount : this.selectedPageCount
    },
    selectorDialogJumpPage() {
      return this.selectorTab === 'all' ? this.selectorJumpPage : this.selectedJumpPage
    },
    isPageFullySelected() {
      return this.goods.length > 0 && this.goods.every((good) => this.selectorSelected.includes(this.productId(good)))
    },
    shopGroups() {
      const groups = [
        { label: '抖店', options: [], disabled: false },
        { label: '微信小店', options: [], disabled: true }
      ]
      this.shops.forEach((shop) => (Number(shop.shop_type) === 2 ? groups[1].options : groups[0].options).push(shop))
      return groups.filter((group) => group.options.length)
    },

    hasClearMethod() {
      return this.methods.some((item) => item.on && item.type === 403)
    },
    hasAdvancedMethod() {
      return this.methods.some((item) => item.on && [104, 105, 107, 108, 110].includes(item.type))
    }
  },
  beforeDestroy() {
    this.previewRequestId++
    this.selectorRequestId++
  },
  mounted() {
    this.loadCategories()
    this.loadShops()
  },
  methods: {
    async loadCategories() {
      try {
        const response = this.ensureSuccess(await getDoudianCategories({ shop_type: 1 }))
        const data = response && response.data ? response.data : response
        const list = Array.isArray(data) ? data : data.list || data.data || []
        this.categoryTree = this.mapCategoryFields(list)
      } catch (error) {
        this.$message.error('加载商品分类失败')
      }
    },
    async loadShops() {
      try {
        const response = this.ensureSuccess(await getAuthSuccessShopList())
        const root = response && response.data ? response.data : response
        this.shops = Array.isArray(root) ? root : (root && (root.list || root.data)) || []
      } catch (error) {
        this.$message.error('加载店铺失败')
      }
    },
    mapCategoryFields(categories) {
      if (!Array.isArray(categories)) return []
      return categories.map((item) => ({
        category_id: item.id || item.category_id,
        category_name: item.name || item.category_name,
        category_parent_id: item.parent_id || item.category_parent_id,
        category_level: item.level || item.category_level,
        category_is_leaf: item.is_leaf || item.category_is_leaf,
        children: item.children ? this.mapCategoryFields(item.children) : []
      }))
    },
    productId(good) {
      return Number(good && (good.id ?? good.product_id ?? good.distribute_product_id ?? good.platform_product_id))
    },
    titleOf(good) {
      return (good && (good.title || good.product_title || good.name)) || ''
    },
    priceOf(good) {
      const value = good && (good.product_price ?? good.price ?? good.min_price)
      return value === undefined || value === null ? '价格待定' : `¥${value}`
    },
    imageOf(good) {
      return (good && (good.main_image || good.img || good.image_url)) || ''
    },
    isPreviewError(good) {
      return good.preview_result === 'failed'
    },
    cleanValue(value) {
      if (Array.isArray(value)) return value.filter((item) => item !== '' && item !== null && item !== undefined)
      if (value && typeof value === 'object')
        return Object.keys(value).reduce((result, key) => {
          const cleaned = this.cleanValue(value[key])
          if (
            cleaned !== '' &&
            cleaned !== null &&
            cleaned !== undefined &&
            !(Array.isArray(cleaned) && !cleaned.length)
          )
            result[key] = cleaned
          return result
        }, {})
      return value
    },
    buildQueryPayload() {
      const product_filter = buildBatchProductFilter(
        this.filterValues,
        this.store,
        this.excludedProductIds,
        this.mode,
        this.selectedPlatformProductIds
      )
      const payload = {
        selection_mode: this.mode === 'goods' ? 'products' : 'range',
        product_filter,
        rules: this.methods.filter((m) => m.on).map((m) => ({ type: m.type, options: this.ruleOptions(m.type) })),
        conditions: { skip_existing: this.conditions.skip_existing },
        common_options: { ...this.commonOptions }
      }
      if (this.scheduled && this.scheduleText) payload.scheduled_at = this.scheduleText + ':00'
      return payload
    },
    previewPayloadSignature(query = this.buildQueryPayload()) {
      const { scheduled_at: ignored, ...payload } = query
      const normalize = (value) => {
        if (Array.isArray(value)) return value.map(normalize)
        if (value && typeof value === 'object')
          return Object.keys(value)
            .sort()
            .reduce((result, key) => ({ ...result, [key]: normalize(value[key]) }), {})
        return value
      }
      return JSON.stringify(normalize(payload))
    },
    handleMethodChange(method, checked) {
      if (!checked) return
      this.methods.forEach((item) => {
        item.on = item === method
      })
      if (![401, 402].includes(method.type)) this.conditions.skip_existing = false
    },
    validateModification() {
      const enabled = this.methods.filter((item) => item.on),
        form = this.form
      const filled = (value) => String(value == null ? '' : value).trim() !== ''
      let message = ''
      if (enabled.length !== 1) message = '请选择一种修改方式'
      else {
        const type = enabled[0].type
        if (type === 401 && !filled(form.value)) message = '请输入统一设置的短标题'
        if (
          type === 402 &&
          (!Number.isInteger(form.length) ||
            form.length < 4 ||
            form.length > 12 ||
            !['head', 'tail'].includes(form.fromTitleDirection))
        )
          message = '请选择 4–12 字及截取方向'
        if (type === 104 && !form.keywords.split(/[,，]/).some(filled)) message = '请输入需要删除的关键词'
        if (type === 105 && !form.filters.length) message = '请至少选择一个过滤项'
        if (
          type === 107 &&
          (!form.replaces.length || form.replaces.length > 100 || form.replaces.some((item) => !filled(item.find)))
        )
          message = '每组替换规则都需要填写查找内容，最多100组'
        if (type === 108 && !filled(form.prefix) && !filled(form.suffix)) message = '请填写前缀或后缀'
        if (type === 110 && !filled(form.before)) message = '请输入替换前的前缀'
        const values = Object.values(this.ruleOptions(type)).flatMap((value) =>
          Array.isArray(value)
            ? value.flatMap((item) => (typeof item === 'object' ? Object.values(item) : item))
            : [value]
        )
        if (values.some((value) => typeof value === 'string' && this.characterCount(value) > 10000))
          message = '单个文本最多10000个字符'
      }
      if (this.mode === 'range') {
        for (const prefix of ['price', 'sales']) {
          const min = this.filterValues[prefix + '_min'],
            max = this.filterValues[prefix + '_max']
          for (const value of [min, max])
            if (
              value !== '' &&
              (!Number.isFinite(Number(value)) ||
                Number(value) < 0 ||
                (prefix === 'sales' && !/^\d+$/.test(String(value))))
            )
              message = '价格需为非负数字，销量需为非负整数'
          if (min !== '' && max !== '' && Number(min) > Number(max)) message = '范围下限不能大于上限'
        }
        const id = this.filterValues.platform_product_id
        if (id && !/^[1-9][0-9]{0,199}$/.test(id)) message = '请输入正确的抖店商品ID'
        if (this.characterCount(this.filterValues.product_title) > 500) message = '标题筛选最多500个字符'
      }
      if (this.selected.length > 10000) message = '每个批次最多选择10000个商品'
      if (message) this.$message.warning(message)
      return !message
    },
    ruleOptions(type) {
      const keys = {
        401: ['value'],
        402: ['length'],
        403: [],
        104: ['keywords'],
        105: ['filters'],
        107: ['replaces'],
        108: ['prefix', 'suffix'],
        110: ['before', 'after']
      }
      const options = (keys[type] || []).reduce((result, key) => ({ ...result, [key]: this.form[key] }), {})
      if (type === 402) options.direction = this.form.fromTitleDirection
      return options
    },
    parsePageResponse(response) {
      const data = response.data
      if (
        !data ||
        !Array.isArray(data.list) ||
        !Number.isInteger(data.total) ||
        !Number.isInteger(data.page) ||
        !Number.isInteger(data.limit)
      )
        throw new Error('预览响应格式不符合约定')
      return data
    },
    ensureSuccess(response) {
      if (Number(response && response.code) !== 200) throw new Error(response?.message || response?.msg || '请求失败')
      return response
    },
    async loadPreview(page = 1) {
      if (this.loading || this.confirming) return
      if (!this.validateModification()) return
      if (
        this.mode === 'goods' &&
        (!this.selected.length || this.selectedPlatformProductIds.length !== this.selected.length)
      )
        return this.$message.warning('请选择包含抖店商品ID的商品')
      const { scheduled_at: ignored, ...payload } = JSON.parse(JSON.stringify(this.buildQueryPayload()))
      const signature = this.previewPayloadSignature(payload)
      const requestId = ++this.previewRequestId
      this.previewSignature = ''
      this.loading = true
      try {
        const result = this.parsePageResponse(
          this.ensureSuccess(
            await previewDoudianShortTitleBatch({
              ...payload,
              page,
              limit: this.previewPage.limit
            })
          )
        )
        if (requestId !== this.previewRequestId || this._isDestroyed || signature !== this.previewPayloadSignature()) {
          if (!this._isDestroyed && requestId === this.previewRequestId) {
            this.previewSignature = ''
            this.$message.warning('修改条件已变化，请重新预览')
          }
          return
        }
        this.previewGoods = Array.isArray(result.list) ? result.list : []
        this.previewPage = {
          page: result.page || page,
          limit: result.limit || this.previewPage.limit,
          total: result.total
        }
        this.previewJumpPage = this.previewPage.page
        this.previewSignature = signature
        this.preview = true
      } catch (error) {
        if (requestId === this.previewRequestId && !this._isDestroyed)
          this.$message.error(error?.response?.data?.message || error?.message || '查询失败')
      } finally {
        if (requestId === this.previewRequestId) this.loading = false
      }
    },
    jumpPreviewPage() {
      const page = Math.min(this.pageCount, Math.max(1, Number(this.previewJumpPage) || 1))
      this.previewJumpPage = page
      if (page !== this.previewPage.page) this.loadPreview(page)
    },
    async startBatch() {
      if (this.loading || this.confirming) return
      if (!this.validateModification()) return
      if (this.scheduled && !this.isFutureSchedule(this.scheduleText))
        return this.$message.warning('定时时间必须晚于当前时间')
      if (
        this.mode === 'goods' &&
        (!this.selected.length || this.selectedPlatformProductIds.length !== this.selected.length)
      )
        return this.$message.warning('请选择包含抖店商品ID的商品')
      if (!this.preview) return this.$message.warning('请先点击修改内容预览')
      if (!this.previewIsCurrent) return this.$message.warning('修改条件已变化，请重新预览')
      if (this.previewPage.total > 10000) return this.$message.warning('每个批次最多10000个商品，请缩小范围')
      if (!this.previewPage.total) return this.$message.warning('当前条件下没有可修改的商品')
      const payload = JSON.parse(JSON.stringify(this.buildQueryPayload()))
      const confirmedPayload = JSON.stringify(payload)
      this.confirming = true
      try {
        const scheduleTip = payload.scheduled_at ? `\n定时执行时间：${payload.scheduled_at}` : ''
        await this.$confirm(
          `商品数${this.previewPage.total}${scheduleTip}\n${batchPreviewNotice}\n${describeCommonOptions(
            payload.common_options
          )}${this.hasClearMethod ? '\n将清空导购短标题，请确认。' : ''}\n是否开始修改？`,
          '确认修改'
        )
        if (this._isDestroyed) return
        if (!this.previewIsCurrent || confirmedPayload !== JSON.stringify(this.buildQueryPayload()))
          return this.$message.warning('修改条件已变化，请重新预览并确认')
        if (payload.scheduled_at && !this.isFutureSchedule(this.scheduleText))
          return this.$message.warning('定时时间必须晚于当前时间')
        this.loading = true
        this.ensureSuccess(await createDoudianShortTitleBatch(payload))
        if (!this._isDestroyed) {
          this.success = true
          this.$emit('created')
        }
      } catch (error) {
        if (error !== 'cancel' && error !== 'close' && !this._isDestroyed)
          this.$message.error(error?.response?.data?.message || error?.message || '创建任务失败')
      } finally {
        this.loading = false
        this.confirming = false
      }
    },
    confirmSchedule() {
      if (!this.isFutureSchedule(this.scheduleDraft)) return this.$message.warning('请选择未来的执行时间')
      this.scheduleText = this.scheduleDraft
      this.closeSchedule()
    },
    formatScheduleTime(date = new Date(Date.now() + 60000)) {
      return new Intl.DateTimeFormat('sv-SE', {
        timeZone: 'Asia/Shanghai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).format(date)
    },
    isFutureSchedule(value) {
      return (
        /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(value) && new Date(value.replace(' ', 'T') + ':00+08:00') > new Date()
      )
    },
    toggleSchedule() {
      if (!this.scheduled) {
        this.schedule = false
        this.scheduleText = ''
        this.scheduleDraft = ''
        return
      }
      if (this.scheduled && !this.scheduleText) this.scheduleText = this.formatScheduleTime()
    },
    openSchedule() {
      this.scheduleDraft = this.scheduleText || this.formatScheduleTime()
      this.schedule = true
    },
    closeSchedule() {
      this.schedule = false
      this.scheduleDraft = ''
    },
    changeSelectorShop(shopId) {
      this.selectorShopId = shopId
      this.querySelector()
    },
    async openSelector() {
      this.selectorShopId = this.selectedGoods[0]?.shop_id || ''
      this.selectorSelected = [...this.selected]
      this.selectorSelectedGoods = [...this.selectedGoods]
      this.selecting = true
      this.selectorTab = 'all'
      this.selectedPage = 1
      this.selectedJumpPage = 1
      await this.loadGoods(this.selectorPage.page)
    },
    closeSelector() {
      this.selectorRequestId++
      this.selectorLoading = false
      this.selecting = false
      this.selectorSelected = []
      this.selectorSelectedGoods = []
    },
    confirmSelector(ids) {
      const products = this.selectorSelectedGoods.filter((good) => ids.includes(this.productId(good)))
      const shopId = Number(products[0]?.shop_id)
      if (!shopId || products.some((good) => Number(good.shop_id) !== shopId))
        return this.$message.warning('只能选择同一家店铺的商品')
      this.store = [shopId]
      this.selected = [...ids]
      this.selectedGoods = this.selectorSelectedGoods.filter((good) => this.selected.includes(this.productId(good)))
      this.closeSelector()
    },
    switchMode(mode) {
      if (this.mode === mode) return
      this.mode = mode
      this.filterValues = searchDefaults()
      this.store = []
      this.selected = []
      this.selectedGoods = []
      this.selectorSelected = []
      this.selectorSelectedGoods = []
      this.selectedPage = 1
      this.selectedJumpPage = 1
      this.excludedProductIds = []
      this.previewGoods = []
      this.previewPage = { ...this.previewPage, page: 1, total: 0 }
      this.previewJumpPage = 1
      this.previewSignature = ''
      this.preview = false
      this.selecting = false
    },
    switchSelectorTab(tab) {
      this.selectorTab = tab
      if (tab === 'selected') {
        this.selectedPage = 1
        this.selectedJumpPage = 1
      }
    },
    querySelector() {
      this.loadGoods(1)
    },
    async loadGoods(page = 1) {
      const filters = JSON.parse(
        JSON.stringify(
          this.cleanValue({
            ...this.selectorFilters,
            ...(this.selectorShopId ? { shop_ids: [this.selectorShopId] } : {})
          })
        )
      )
      const signature = JSON.stringify(filters)
      const pageSize = this.selectorPage.limit
      const requestId = ++this.selectorRequestId
      this.selectorLoading = true
      try {
        const response = this.ensureSuccess(await getProductSelectorProducts({ ...filters, page, page_size: pageSize }))
        if (
          requestId !== this.selectorRequestId ||
          !this.selecting ||
          this._isDestroyed ||
          signature !==
            JSON.stringify(
              this.cleanValue({
                ...this.selectorFilters,
                ...(this.selectorShopId ? { shop_ids: [this.selectorShopId] } : {})
              })
            ) ||
          pageSize !== this.selectorPage.limit
        )
          return
        const root = response && response.data ? response.data : response
        const data = root && root.data && !Array.isArray(root.data) ? root.data : root
        const pagination = (data && data.pagination) || {}
        this.goods = Array.isArray(data && data.list) ? data.list : []
        this.selectorPage = {
          page: Number(pagination.page || page),
          limit: Number(pagination.per_page || pageSize),
          total: Number(pagination.total || 0)
        }
        this.selectorJumpPage = this.selectorPage.page
      } catch (error) {
        if (requestId === this.selectorRequestId && !this._isDestroyed)
          this.$message.error(error?.message || '商品查询失败')
      } finally {
        if (requestId === this.selectorRequestId) this.selectorLoading = false
      }
    },
    jumpSelectorPage() {
      if (this.selectorTab === 'selected') {
        const page = Math.min(this.selectedPageCount, Math.max(1, Number(this.selectedJumpPage) || 1))
        this.selectedPage = page
        this.selectedJumpPage = page
        return
      }
      const page = Math.min(this.selectorPageCount, Math.max(1, Number(this.selectorJumpPage) || 1))
      this.selectorJumpPage = page
      if (page !== this.selectorPage.page) this.loadGoods(page)
    },
    changeSelectorPage(page) {
      if (this.selectorTab === 'all') {
        this.loadGoods(page)
        return
      }
      this.selectedPage = Math.min(this.selectedPageCount, Math.max(1, Number(page) || 1))
      this.selectedJumpPage = this.selectedPage
    },
    changeSelectorPageSize(size) {
      this.selectorPage.limit = Number(size)
      this.selectedPage = Math.min(this.selectedPageCount, this.selectedPage)
      this.selectedJumpPage = this.selectedPage
      if (this.selectorTab === 'all') this.querySelector()
    },
    changeSelectorJumpPage(value) {
      if (this.selectorTab === 'all') this.selectorJumpPage = Number(value)
      else this.selectedJumpPage = Number(value)
    },
    syncSelectedPage() {
      this.selectedPage = Math.min(this.selectedPage, this.selectedPageCount)
      this.selectedJumpPage = this.selectedPage
    },
    togglePageSelection() {
      const ids = this.goods.map((good) => this.productId(good))
      if (this.isPageFullySelected) {
        this.selectorSelected = this.selectorSelected.filter((id) => !ids.includes(id))
        this.selectorSelectedGoods = this.selectorSelectedGoods.filter((good) => !ids.includes(this.productId(good)))
        this.syncSelectedPage()
        return
      }
      const shopId = Number(this.selectorSelectedGoods[0]?.shop_id || this.goods[0]?.shop_id)
      if (this.goods.some((good) => Number(good.shop_id) !== shopId))
        return this.$message.warning('只能选择同一家店铺的商品，请先筛选店铺')
      this.goods.forEach((good) => {
        if (!this.selectorSelected.includes(this.productId(good))) this.toggleGood(good)
      })
      this.syncSelectedPage()
    },
    isExcluded(good) {
      return this.excludedProductIds.includes(this.productId(good))
    },
    toggleExclude(good) {
      const id = this.productId(good)
      this.excludedProductIds = this.excludedProductIds.includes(id)
        ? this.excludedProductIds.filter((item) => item !== id)
        : [...this.excludedProductIds, id]
    },
    resetFilters() {
      this.filterValues = searchDefaults()
      this.store = []
      this.previewGoods = []
      this.previewPage = { ...this.previewPage, page: 1, total: 0 }
      this.previewJumpPage = 1
      this.previewSignature = ''
      this.preview = false
    },
    toggleGood(good) {
      if (
        !this.selectorSelected.includes(this.productId(good)) &&
        this.selectorSelectedGoods.length &&
        Number(this.selectorSelectedGoods[0].shop_id) !== Number(good.shop_id)
      )
        return this.$message.warning('只能选择同一家店铺的商品')
      const id = this.productId(good)
      this.selectorSelected = this.selectorSelected.includes(id)
        ? this.selectorSelected.filter((item) => item !== id)
        : [...this.selectorSelected, id]
      this.selectorSelectedGoods = this.selectorSelectedGoods.some((item) => this.productId(item) === id)
        ? this.selectorSelectedGoods.filter((item) => this.productId(item) !== id)
        : [...this.selectorSelectedGoods, good]
      this.syncSelectedPage()
    },
    addReplace() {
      if (this.form.replaces.length >= 100) return this.$message.warning('最多添加100组替换规则')
      this.form.replaces.push({ find: '', value: '' })
    },
    removeReplace(index) {
      this.form.replaces.splice(index, 1)
    },
    resetMoreSearch() {
      this.moreSearchDraft = [...this.moreSearchFields]
    },
    openMoreSearch() {
      this.moreSearchDraft = [...this.moreSearchChecked]
      this.moreSearch = true
    },
    closeMoreSearch() {
      this.moreSearch = false
      this.moreSearchDraft = []
    },
    applyMoreSearch() {
      this.moreSearchChecked = this.moreSearchFields.filter((field) => this.moreSearchDraft.includes(field))
      this.closeMoreSearch()
    },
    characterCount(value) {
      return Array.from(String(value == null ? '' : value)).length
    },
    isMethodDisabled(method) {
      return !method.on && this.methods.some((item) => item.on)
    },
    setFromTitleDirection(direction, checked) {
      if (checked) this.form.fromTitleDirection = direction
    },
    previewShortTitle(good) {
      if (good.new_value_ready === false || (good.new_value_ready === undefined && good.preview_result === 'unknown'))
        return '本地数据缺失，待核验'
      if (good.operation === 'clear') return '清空'
      if (good.new_short_title == null) return '未设置'
      return good.new_short_title
    }
  }
}
</script>
<style scoped>
.crumb a {
  margin-left: auto;
  color: #1677ff;
}
.field input,
.field select,
.rule-options input,
.rule-options select,
.rule-options textarea {
  box-sizing: border-box;
  width: 100%;
  height: 28px;
  padding: 4px 8px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  font-size: 11px;
}
.bm-title__datetime-range {
  width: 100%;
}
::v-deep(.bm-title__datetime-range.el-date-editor) {
  height: 28px;
}
::v-deep(.bm-title__datetime-range .el-range-input),
::v-deep(.bm-title__datetime-range .el-range-separator),
::v-deep(.bm-title__datetime-range .el-range__icon) {
  font-size: 11px;
  line-height: 20px;
}
.range span {
  color: #999;
}
.panel.filters footer {
  grid-column: 1/-1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding-top: 9px;
  border-top: 1px solid #f0f0f0;
  font-size: 12px;
}
.panel.filters footer span {
  margin-right: auto;
  color: #999;
}
.panel.filters b {
  color: #1677ff;
}
.panel.filters button,
.bm-title__small-modal footer button {
  height: 28px;
  padding: 0 13px;
  border: 0;
  border-radius: 4px;
  background: #c8443c;
  color: #fff;
  font-size: 12px;
}
.panel.filters .plain,
.bm-title__small-modal .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}
.methods article {
  padding: 12px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}
.methods article:last-child {
  border-bottom: 0;
}
.bm-title__method-name {
  font-weight: 500;
}
.rule-options {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0 0 22px;
  color: #666;
}
.rule-options input {
  width: 190px;
}
.rule-options input.long {
  width: 360px;
}
.rule-options textarea {
  width: 360px;
  height: 62px;
  resize: vertical;
}
.rule-options select {
  width: 145px;
}
.rule-options small {
  color: #999;
  font-size: 10px;
}
.rule-options .warning {
  color: #c8443c;
}
.bm-title__replace {
  display: flex;
  align-items: center;
  gap: 8px;
}
.bm-title__replace button {
  height: 28px;
  padding: 0 10px;
  border: 1px solid #91caff;
  border-radius: 4px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 11px;
}
.preview header {
  padding: 10px 14px;
  border-bottom: 1px solid #e0e0ec;
  font-size: 12px;
}
.preview header b {
  color: #1677ff;
}
.preview header button {
  float: right;
  border: 0;
  background: none;
  color: #c8443c;
}
.bm-title__col-product {
  width: 45%;
}
.bm-title__col-new-title {
  width: 45%;
}
.bm-title__col-action {
  width: 10%;
}
.preview th:nth-child(3),
.preview td:nth-child(3) {
  text-align: center;
}
.bm-title__product-info {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.preview p {
  display: -webkit-box;
  overflow: hidden;
  margin: 4px 0 0;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 18px;
}
.preview small {
  color: #999;
}
.bm-title__product-ids {
  display: flex;
  align-items: center;
  gap: 12px;
}
.bm-title__empty-row td {
  height: 120px;
  color: #999;
  text-align: center;
}
.preview textarea {
  width: 100%;
  padding: 5px 8px 18px;
  border: 1px solid rgb(224, 224, 236);
  border-radius: 4px;
  outline: none;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 11px;
  color: rgb(26, 26, 46);
  resize: none;
  box-sizing: border-box;
  line-height: 1.6;
}
.preview td button {
  height: 24px;
  padding: 0 10px;
  border: 1px solid #91caff;
  border-radius: 3px;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 10px;
  white-space: nowrap;
}
.preview tr.is-excluded td {
  background: #fff7f7;
  color: #8c5a5a;
}
.preview tr.is-excluded .bm-title__product-info,
.preview tr.is-excluded textarea {
  opacity: 0.72;
}
.preview td button.is-excluded {
  border-color: #f0a5a5;
  background: #fff1f0;
  color: #c8443c;
}
.preview tr.is-error td {
  background: #fff7f7;
}
.preview textarea.is-error {
  border-color: #f56c6c;
}
.preview textarea.is-unchanged {
  background: #fff7e6;
}
.bm-title__preview-error {
  margin-top: 5px;
  color: #d93025;
  font-size: 11px;
  line-height: 1.5;
}
.bm-title__image {
  display: inline-flex;
  width: 56px;
  height: 56px;
  flex: 0 0 56px;
  align-items: center;
  justify-content: center;
  border: 1px solid #ffccd2;
  border-radius: 4px;
  background: #fff5f5;
  font-size: 16px;
}
.bm-title__pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
  padding: 0 14px;
  border-top: 1px solid #ebeef5;
  color: #666;
  font-size: 12px;
}
.bm-title__pagination-actions,
.bm-title__pagination-jump {
  display: flex;
  align-items: center;
  gap: 8px;
}
.bm-title__pagination ::v-deep(.el-pagination) {
  padding: 0;
}
.bm-title__pagination ::v-deep(.el-pager li),
.bm-title__pagination ::v-deep(.btn-prev),
.bm-title__pagination ::v-deep(.btn-next) {
  min-width: 28px;
  height: 28px;
  margin: 0 2px;
  border: 1px solid #dfe3eb;
  border-radius: 3px;
  line-height: 26px;
}
.bm-title__pagination ::v-deep(.el-pager li.active) {
  border-color: #1677ff;
  color: #1677ff;
}
.bm-title__pagination-jump input {
  width: 34px;
  height: 28px;
  box-sizing: border-box;
  border: 1px solid #dfe3eb;
  border-radius: 3px;
  text-align: center;
}
.bm-title__mask {
  position: fixed;
  z-index: 3000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(3px);
}
.bm-title__small-modal {
  width: min(760px, 100%);
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}
.bm-title__small-modal {
  width: min(400px, 100%);
}
.bm-title__small-modal > header {
  display: flex;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 14px;
}
.bm-title__small-modal > header button {
  width: 24px;
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 18px;
}
.bm-title__small-modal main {
  padding: 24px 20px;
  font-size: 13px;
}
.bm-title__small-modal main label {
  display: flex;
  align-items: center;
  gap: 10px;
}
.bm-title__small-modal main input {
  height: 28px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
}
.bm-title__schedule-picker {
  width: 240px;
}
.bm-title__small-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e0e0ec;
}
.bm-title__small-modal .success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.bm-title__small-modal .success-message b {
  display: flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f6ffed;
  color: #52c41a;
  font-size: 28px;
}
.bm-title__small-modal .success-message p {
  margin: 12px 0 5px;
}
.bm-title__small-modal .success-message small {
  color: #999;
}
@media (max-width: 520px) {
  .rule-options input,
  .rule-options input.long,
  .rule-options textarea {
    width: 100%;
  }
}
.bm-title__method-name {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #1a1a2e;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  cursor: pointer;
}
.bm-title__method-name input,
.rule-options input[type='checkbox'],
.rule-options input[type='radio'] {
  width: 14px;
  height: 14px;
  min-width: 14px;
  margin: 0;
  padding: 0;
  accent-color: #1677ff;
  cursor: pointer;
}
.rule-options {
  align-items: center;
  margin-top: 10px;
  padding-left: 22px;
  line-height: 28px;
}
.rule-options > label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  cursor: pointer;
}
.rule-options > span {
  flex-shrink: 0;
  color: #666;
  font-size: 12px;
}
.rule-options .bm-title__count-input,
.rule-options .bm-title__count-textarea {
  position: relative;
  line-height: normal;
}
.rule-options .bm-title__count-input input {
  width: 360px;
}
.rule-options .bm-title__count-input small,
.rule-options .bm-title__count-textarea small {
  position: absolute;
  right: 8px;
  bottom: 5px;
  color: #999;
  font: 10px 'JetBrains Mono', monospace;
}
.rule-options .bm-title__count-textarea textarea {
  width: 360px;
  padding-bottom: 18px;
}
.rule-options .bm-title__replace {
  width: 100%;
  gap: 8px;
}
.rule-options .bm-title__replace input {
  width: 160px;
}
.bm-title__replace .danger {
  border-color: #ffccd2;
  background: #fff5f5;
  color: #c8443c;
}
.rule-options .bm-title__inline {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.rule-options .bm-title__inline input:not([type='checkbox']):not([type='radio']) {
  width: 200px;
}
.rule-options select:disabled {
  background: #f5f5f5;
  color: #999;
}
.rule-options > .warning {
  display: block;
  width: 100%;
  line-height: 16px;
}
.methods article {
  padding: 14px 14px 13px;
}
::v-deep(.methods .el-checkbox__inner) {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}
::v-deep(.methods .el-checkbox__inner:hover),
::v-deep(.methods .el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: #d4a946;
}
::v-deep(.methods .el-checkbox__input.is-checked .el-checkbox__inner),
::v-deep(.methods .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  border-color: #d4a946;
  background: #d4a946;
}
::v-deep(.methods .el-checkbox__label) {
  color: #1a1a2e;
  font-size: 12px;
}
::v-deep(.methods .el-checkbox__input.is-checked + .el-checkbox__label) {
  color: #1a1a2e;
}
.bm-title__filter-select {
  display: block;
  width: 100%;
}
.bm-title__store-select {
  width: 220px;
}
.panel.filters footer > div {
  display: flex;
  align-items: center;
  gap: 8px;
}
.panel.filters .add-store {
  background: #722ed1;
}
.panel.filters .add-store:hover {
  background: #531dab;
}
::v-deep(.bm-title__filter-select .el-input__inner),
::v-deep(.bm-title__store-select .el-input__inner) {
  height: 28px;
  padding: 0 28px 0 8px;
  border-color: #e0e0ec;
  border-radius: 4px;
  color: #1a1a2e;
  font-size: 12px;
  line-height: 28px;
  text-align: left;
}
::v-deep(.bm-title__filter-select .el-input__suffix),
::v-deep(.bm-title__store-select .el-input__suffix) {
  right: 7px;
}
::v-deep(.bm-title__filter-select .el-input__icon),
::v-deep(.bm-title__store-select .el-input__icon) {
  color: #999;
  font-size: 14px;
  line-height: 28px;
}
::v-deep(.bm-title__filter-select .el-input__inner:focus),
::v-deep(.bm-title__store-select .el-input__inner:focus) {
  border-color: #d4a946;
}
.panel.filters .more-search {
  padding: 0 2px;
  background: transparent;
  color: #1677ff;
}
.bm-title__more-modal {
  width: min(540px, 100%);
  overflow: hidden;
  border: 1px solid #e0e0ec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}
.bm-title__more-modal > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 18px;
  border-bottom: 1px solid #e0e0ec;
  background: #fafafa;
  font-size: 14px;
}
.bm-title__more-modal > header button {
  width: 24px;
  height: 24px;
  border: 1px solid #e0e0ec;
  border-radius: 4px;
  background: #fff;
  color: #666;
  font-size: 18px;
}
.bm-title__more-modal main {
  padding: 16px 18px;
}
.bm-title__more-modal .el-checkbox-group {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}
.bm-title__more-modal footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e0e0ec;
}
.bm-title__more-modal footer button {
  height: 28px;
  padding: 0 13px;
  border: 0;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 12px;
}
.bm-title__more-modal footer .plain {
  border: 1px solid #e0e0ec;
  background: #fff;
  color: #666;
}
::v-deep(.bm-title__more-modal .el-checkbox__inner) {
  width: 14px;
  height: 14px;
  border-color: #d9c98d;
  border-radius: 3px;
}
::v-deep(.bm-title__more-modal .el-checkbox__input.is-checked .el-checkbox__inner) {
  border-color: #d4a946;
  background: #d4a946;
}
::v-deep(.bm-title__more-modal .el-checkbox__label) {
  color: #1a1a2e;
  font-size: 12px;
}
.panel.filters > footer {
  justify-content: space-between;
}

.bm-title__selector-category {
  width: 150px;
  flex: 0 0 150px;
}
.bm-title__selector-platform-id,
.bm-title__selector-title {
  height: 32px;
  box-sizing: border-box;
  padding: 0 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #606266;
}
.bm-title__selector-platform-id {
  width: 112px;
}
.bm-title__selector-title {
  width: 136px;
}
.bm-title__selector-platform-id:focus,
.bm-title__selector-title:focus {
  border-color: #409eff;
  outline: 0;
}
.bm-title__selector-date {
  width: 160px;
  flex: 0 0 160px;
}
.bm-title__selector-status {
  width: 92px;
  flex: 0 0 92px;
}
.bm-title__selector-query {
  height: 32px;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  background: #1677ff;
  color: #fff;
  font-size: 11px;
}

/* 商品选择弹窗：与批量修改设计稿一致的紧凑卡片布局。 */

.bm-short-title__notice,
.bm-short-title__stale {
  color: #8a6b29;
  font-size: 12px;
  line-height: 1.7;
}
.bm-short-title__strategy-body {
  padding: 14px 18px;
}
.preview .is-unknown {
  background: #fffbe6;
}
.preview .is-unknown .bm-title__preview-error {
  color: #8a6b29;
}
.bm-short-title__from-title-options {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.bm-short-title__length-input {
  width: 92px;
}
.bm-title__count-input,
.bm-title__count-textarea {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.bm-title__count-textarea {
  align-items: flex-end;
}
.bm-title__count-textarea textarea {
  width: 400px;
  max-width: 100%;
  min-height: 70px;
}
.bm-title__inline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.rule-options {
  min-width: 0;
}
.preview small,
.preview p {
  overflow-wrap: anywhere;
}
@media (max-width: 768px) {
  .panel.filters > footer {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .bm-title__store-select {
    width: 100%;
  }
  .panel.filters > footer > div:last-child {
    justify-content: flex-end;
  }
  .panel.filters footer button {
    white-space: nowrap;
    flex-shrink: 0;
  }
  .bm-title__count-input,
  .bm-title__replace {
    flex-wrap: wrap;
    width: 100%;
  }
  .rule-options input.long,
  .bm-title__replace input {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }
  .bm-title__count-textarea {
    width: 100%;
  }
  .bm-title__count-textarea textarea {
    min-width: 0;
  }
  .rule-options {
    flex-wrap: wrap;
  }
  .bm-short-title__from-title-options {
    width: 100%;
  }
}
</style>

<style scoped src="./batch-modify.css"></style>
